import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { IdentityService } from './identity.service';

export function provideIdentityService(): EnvironmentProviders {
    return makeEnvironmentProviders([
        IdentityService,
        {
            provide: APP_INITIALIZER,
            useFactory: (identityService: IdentityService) => () => identityService.init(),
            deps: [IdentityService],
            multi: true,
        },
    ]);
}
